import { Button, Card, CardContent, Stack, Typography } from '@mui/material';
import SchoolRounded from '@mui/icons-material/SchoolRounded';
import { Link as RouterLink } from 'react-router';

/** Home card: the way into Lousa ENEM (students of institutions find it here too). */
export function HomeStudent() {
  return (
    <Card>
      <CardContent>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={2}
          sx={{ alignItems: { sm: 'center' } }}
        >
          <SchoolRounded color="primary" sx={{ fontSize: 40 }} />
          <Stack sx={{ flex: 1 }}>
            <Typography variant="h6" component="h2">
              Lousa ENEM
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Simulados no formato do ENEM do tamanho que você quiser, no tempo oficial, e redação
              corrigida nas cinco competências.
            </Typography>
          </Stack>
          <Button variant="contained" component={RouterLink} to="/enem">
            Abrir
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
}
